import { Modal } from "@circle-react-uikit/ModalV2";
import type { ReactNode } from "react";

import { useIsCompassModal } from "./UpgradePlanModalConfigContext";

interface UpgradePlanModalBodyProps {
  children: ReactNode;
  className?: string;
}

export const UpgradePlanModalBody = ({
  children,
  className,
}: UpgradePlanModalBodyProps) => {
  const isCompassModal = useIsCompassModal();

  if (isCompassModal) {
    return <>{children}</>;
  }

  return <Modal.Body className={className}>{children}</Modal.Body>;
};
